import Swal from "sweetalert2";
import { ADDQUOTATION, UPDATEQUOTATION } from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const addQuetation = async (payload, callback) => {
  await axios.post(ADDQUOTATION, payload).then((res) => {
    callback(res);
    if (res?.data?.succeeded) {
      Swal.fire({
        title:res?.data?. message,
        icon: "success",

        ...swalAlertPopProps,
      });
      // getAllData()
      // setOpen(false)
    } else {
      Swal.fire({
        title: res?.data?.message,
        icon: "error",

        ...swalAlertPopProps,
      });
    }
  });
};

export const updateQuetation = async (payload, callback) => {
    await axios.post(UPDATEQUOTATION, payload).then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          title:           res?.data?. message,
          icon: "success",
  
          ...swalAlertPopProps,
        });
        // getAllData()
        // setOpen(false)
      } else {
        Swal.fire({
          title: res?.data?.message,
          icon: "error",
  
          ...swalAlertPopProps,
        });
      }
    });
  };
  

